// extracted by mini-css-extract-plugin
export default {"toggle_container":"style_toggle_container__fpOZi","switch":"style_switch__H7iSS","slider":"style_slider__Mn4O6","round":"style_round__lCWyH","label":"style_label__qacDb"};